import React from 'react';
import { LEGAL } from './legalConfig';

/** Two REQUIRED, UNTICKED checkboxes. value = { terms: bool, privacy: bool }.
 *  Disable the submit / Google button until value.terms && value.privacy. */
export default function ConsentCheckboxes({ value, onChange, updated = false, className = '' }) {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.checked });
  const link = (to, label) => (
    <a href={to} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>{label}</a>
  );
  return (
    <div className={className} data-testid="consent-checkboxes" style={{ display: 'grid', gap: 8, fontSize: 13 }}>
      <label style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
        <input type="checkbox" checked={!!value.terms} onChange={set('terms')} data-testid="consent-terms" required />
        <span>
          {updated ? 'I agree to the updated ' : `I am ${LEGAL.minAge} or older and I agree to the `}
          {link(LEGAL.routes.terms, 'Terms of Service')}.
        </span>
      </label>
      <label style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
        <input type="checkbox" checked={!!value.privacy} onChange={set('privacy')} data-testid="consent-privacy" required />
        <span>
          I have read the {link(LEGAL.routes.privacy, 'Privacy Policy')} and{' '}
          {link(LEGAL.routes.cookies, 'Cookie Policy')} and I consent to {LEGAL.appName} processing my personal data as described.
        </span>
      </label>
    </div>
  );
}

/** Shown on the LOGIN screen (email and Google): signing in means the user accepts the current Terms and Privacy Policy. */
export function LoginLegalNotice({ className = '' }) {
  const link = (to, label) => (
    <a href={to} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>{label}</a>
  );
  return (
    <p className={className} data-testid="login-legal-notice" style={{ fontSize: 12 }}>
      By logging in (including with Google) you agree to the {link(LEGAL.routes.terms, 'Terms of Service')} and{' '}
      {link(LEGAL.routes.privacy, 'Privacy Policy')} and acknowledge the {link(LEGAL.routes.cookies, 'Cookie Policy')}.
    </p>
  );
}
